<template>
  <div>
    <v-container>
      <h5>Top Close Reason</h5>
      <date-filter
        v-model="selectedDate"
        :default-filter="'last_7_days'"
        @changeDate="handleFilterDate"
      />

      <template v-if="rawData">
        <div class="mt-5 mb-4">
          <ReasonItems :items="rawData.close_reason_level_1" level="1" />
        </div>
        <div class="mb-4">
          <ReasonItems :items="rawData.close_reason_level_2" level="2" />
        </div>
        <div>
          <ReasonItems :items="rawData.close_reason_level_3" level="3" />
        </div>
      </template>
    </v-container>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import ntApi from '@/api/nt.js'
import { mapGetters } from 'vuex'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import ReasonItems from './ReasonItems.vue'

export default {
  components: {
    DateFilter,
    ReasonItems
  },
  data() {
    return {
      rawData: null,
      selectedDate: {
        start: dayjs().subtract(7, 'days').format('YYYY-MM-DD'),
        end: dayjs().format('YYYY-MM-DD')
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    this.handleFetchData()
  },
  methods: {
    async handleFetchData() {
      const vm = this
      try {
        const data = {
          page_id: vm.selectedBot.pageid,
          date_from: vm.selectedDate.start,
          date_to: vm.selectedDate.end
        }

        vm.$store.dispatch('loading')
        const response = await ntApi.getDashboardReason({
          config: {
            params: data
          }
        })
        vm.$store.dispatch('clear_loading')

        if (response && response.status === 200) {
          vm.rawData = response.data
        }
      } catch (error) {
        console.error(error)
      } finally {
        vm.$store.dispatch('clear_loading')
      }
    },
    handleFilterDate() {
      this.handleFetchData()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/nt/Reason/index.vue